import * as msal from "@azure/msal-browser";
import { msalConfig } from "../constants/authConfig";

const msalInstance = new msal.PublicClientApplication(msalConfig);

export default msalInstance;
